import { updateCurrUser } from "../../../actions/auth";
import { setSelectedView } from "../../../actions/task";
import { label } from "../../../config";
import store from "../../../store";

export const FILTER_VIEW_OPTIONS = [
  { label: label.GRID, value: label.GRID },
  { label: label.PIVOT, value: label.PIVOT },
];

/** Matches API / getTeamFilterUtilities: Grid = 1, Pivot = 2. */
export const TEAM_FILTER_VIEW_ID = { GRID: 1, PIVOT: 2 };

export const resolveFilterView = (teamFilterData, lastSelectedBoard) => {
  if (teamFilterData?.filterView) return teamFilterData.filterView;
  return lastSelectedBoard === label.PIVOT ? label.PIVOT : label.GRID;
};

/** Save/update payload `selectedView`: prefer numeric id from API; else map `filterView`. */
export const teamFilterPayloadSelectedView = (teamFilterData) => {
  const n = Number(teamFilterData?.selectedView);
  if (n === TEAM_FILTER_VIEW_ID.PIVOT || n === TEAM_FILTER_VIEW_ID.GRID) return n;
  return teamFilterData?.filterView === label.PIVOT ? TEAM_FILTER_VIEW_ID.PIVOT : TEAM_FILTER_VIEW_ID.GRID;
};

/** Applies Grid / Pivot selection to the active task board view. */
export const applyFilterViewSelection = (filterView) => {
  if (!filterView) return;
  const dispatch = store.dispatch;
  if (filterView === label.PIVOT) {
    dispatch(setSelectedView(label.PIVOT));
    dispatch(updateCurrUser({ lastSelectedBoard: label.PIVOT }));
    localStorage.setItem("lastSelectedBoard", label.PIVOT);
    return;
  }
  dispatch(setSelectedView(label.LIST_VIEW));
  dispatch(updateCurrUser({ lastSelectedBoard: label.GRID }));
  localStorage.setItem("lastSelectedBoard", label.GRID);
};

export const FILTER_SHOW_LABELS = {
  GROUPING: "Grouping",
  TOTALS: "Totals",
  SUB_TOTALS: "Sub-Totals",
};

/** Default on when unset; only explicit false / 0 / "0" turns grouping off (avoids Boolean("0") === true). */
export const normalizeEnableGrouping = (value) =>
  Boolean(value !== false && value !== 0 && value !== "0");

export const isGridFilterView = (teamFilterData, lastSelectedBoard) =>
  resolveFilterView(teamFilterData, lastSelectedBoard) === label.GRID;

export const isGridGroupingEnabled = (teamFilterData) => normalizeEnableGrouping(teamFilterData?.enableGrouping);
